import React from "react";
import { FilasEsperaPage } from "./filasEspera.page";
import { FilasEsperaProvider } from "./context/filas-espera-context";

export function FilasEsperaFactory() {
    return (
        <FilasEsperaProvider>
            <FilasEsperaPage></FilasEsperaPage>
        </FilasEsperaProvider>
    );
}
